import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import useAffordance from 'Hooks/useAffordance';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import MyClients from './MyClients';

const Container = (props) => {
  const { userResource } = useUserContext();
  const {
    collection: householdSummaryColl,
    loading,
    loadingError,
  } = useAffordance(userResource?.relationship(fr.relationships.householdSummary.name).link('related'));

  return (
    <DataContainer
      component={MyClients}
      componentProps={{
        ...props,
        householdSummaryColl,
      }}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

export default Container;
